module.exports = global["moment"] = require("-!./moment.js");


//////////////////
// WEBPACK FOOTER
// ./~/moment/moment.js-exposed
// module id = 7
// module chunks = 2 3